import { render, staticRenderFns } from "./AcceptSuccessPage.vue?vue&type=template&id=684e3d8c&scoped=true&"
import script from "./AcceptSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./AcceptSuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptSuccessPage.vue?vue&type=style&index=0&id=684e3d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e3d8c",
  null
  
)

export default component.exports